<div
  class="row"
  *ngIf="snapshot$ | async as snapshot"
>
  <div class="col-12">
    <app-card
      #speedTestCard
      [hidHeader]="true"
    >
      <div class="card-title">
        <div class="d-flex align-items-start justify-content-between flex-wrap gap-2">
          <div>
            <h5 class="mb-1">
              <i class="feather icon-activity me-2"></i>
              Prueba de velocidad
            </h5>
            <p class="text-muted mb-0">Mida download, upload, ping y jitter desde su red.</p>
          </div>
        </div>
        <hr />
      </div>

      <div
        *ngIf="maintenanceMode"
        class="speed-test-maintenance"
      >
        <p class="speed-test-maintenance-title">En mantenimiento</p>
        <p class="speed-test-maintenance-copy text-muted mb-0">
          La prueba de velocidad no está disponible temporalmente. Vuelva a intentarlo más tarde.
        </p>
      </div>

      <ng-container *ngIf="!maintenanceMode">
      <section
        class="speed-test-prep"
        [class.speed-test-prep--collapsed]="!recommendationsOpen"
        aria-labelledby="speed-test-prep-title"
      >
        <button
          type="button"
          class="speed-test-prep-toggle"
          [attr.aria-expanded]="recommendationsOpen"
          aria-controls="speed-test-prep-steps"
          (click)="toggleRecommendations()"
        >
          <span class="speed-test-prep-toggle-copy">
            <span
              id="speed-test-prep-title"
              class="speed-test-prep-title"
            >
              {{ recommendationsOpen ? 'Antes de iniciar' : 'Recomendaciones para una medición precisa' }}
            </span>
            <span
              *ngIf="recommendationsOpen"
              class="speed-test-prep-summary text-muted"
            >
              Siga estos pasos para obtener una medición representativa del enlace.
            </span>
          </span>
          <span class="speed-test-prep-toggle-action text-muted">
            {{ recommendationsOpen ? 'Ocultar' : 'Ver' }}
          </span>
        </button>

        <div id="speed-test-prep-steps">
          <ol
            *ngIf="recommendationsOpen"
            class="speed-test-prep-steps"
            aria-label="Pasos recomendados"
          >
            <li
              *ngFor="let step of preparationSteps; let i = index"
              class="speed-test-prep-step"
            >
              <span
                class="speed-test-prep-index"
                aria-hidden="true"
              >
                {{ i + 1 }}
              </span>
              <span class="speed-test-prep-copy">
                <span class="speed-test-prep-step-title">{{ step.title }}</span>
                <span class="speed-test-prep-step-detail text-muted">{{ step.detail }}</span>
              </span>
            </li>
          </ol>
        </div>
      </section>

      <div
        *ngIf="showActionsBar(snapshot)"
        class="speed-test-actions d-flex flex-column flex-sm-row align-items-sm-center gap-2"
      >
        <button
          *ngIf="showStartButton(snapshot)"
          type="button"
          class="btn"
          [class.btn-primary]="!isBusy(snapshot)"
          [class.btn-outline-secondary]="isBusy(snapshot)"
          [disabled]="!isBusy(snapshot) && isStartDisabled()"
          (click)="isBusy(snapshot) ? cancel() : start()"
        >
          {{ actionLabel(snapshot.status) }}
        </button>
        <button
          *ngIf="showRetryVerification(snapshot)"
          type="button"
          class="btn btn-outline-secondary"
          (click)="retryVerification()"
        >
          Reintentar verificación
        </button>
        <button
          *ngIf="snapshot.status === 'completed'"
          type="button"
          class="btn btn-outline-secondary"
          (click)="downloadReport(snapshot)"
        >
          Descargar reporte
        </button>
        <span
          *ngIf="showPhaseLabel(snapshot)"
          class="text-muted"
          aria-live="polite"
        >
          {{ phaseLabel(snapshot.status) }}
          <i
            *ngIf="snapshot.status === 'completed'"
            class="feather icon-check-circle ms-1"
            aria-hidden="true"
          ></i>
        </span>
      </div>

      <p
        class="speed-test-link-status"
        [class.mb-3]="showMeasurementPanel()"
        [class.mb-0]="!showMeasurementPanel()"
        [class.text-success]="canStart && !linkChecking"
        [class.text-danger]="!canStart && !linkChecking"
        [class.text-muted]="linkChecking"
        aria-live="polite"
      >
        {{ linkStatusMessage() }}
      </p>

      <div
        *ngIf="isBusy(snapshot)"
        class="progress speed-test-progress mb-4"
      >
        <div
          class="progress-bar"
          role="progressbar"
          [class.progress-bar-striped]="!hasPhaseProgress(snapshot.status)"
          [class.progress-bar-animated]="!hasPhaseProgress(snapshot.status)"
          [style.width.%]="hasPhaseProgress(snapshot.status) ? progressPercent(snapshot) : 100"
          [attr.aria-valuenow]="hasPhaseProgress(snapshot.status) ? progressPercent(snapshot) : null"
          [attr.aria-valuetext]="phaseLabel(snapshot.status)"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>

      <div
        *ngIf="snapshot.status === 'failed' && snapshot.errorMessage"
        class="alert alert-danger"
        role="alert"
      >
        {{ snapshot.errorMessage }}
      </div>

      <ng-container *ngIf="showMeasurementPanel()">
      <div class="row g-3">
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card speed-test-metric h-100">
            <div class="card-body">
              <p class="speed-test-metric-label text-muted mb-2">
                <i class="feather icon-arrow-down me-1"></i>
                Download
              </p>
              <div class="d-flex align-items-baseline gap-1">
                <span class="speed-test-metric-number">
                  {{ snapshot.downloadMbps === null ? '—' : (snapshot.downloadMbps | number : '1.2-2') }}
                </span>
                <small class="speed-test-metric-unit text-muted">Mbps</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card speed-test-metric h-100">
            <div class="card-body">
              <p class="speed-test-metric-label text-muted mb-2">
                <i class="feather icon-arrow-up me-1"></i>
                Upload
              </p>
              <div class="d-flex align-items-baseline gap-1">
                <span class="speed-test-metric-number">
                  {{ snapshot.uploadMbps === null ? '—' : (snapshot.uploadMbps | number : '1.2-2') }}
                </span>
                <small class="speed-test-metric-unit text-muted">Mbps</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card speed-test-metric h-100">
            <div class="card-body">
              <p class="speed-test-metric-label text-muted mb-2">
                <i class="feather icon-radio me-1"></i>
                Ping
              </p>
              <div class="d-flex align-items-baseline gap-1">
                <span class="speed-test-metric-number">
                  {{ snapshot.pingMs === null ? '—' : (snapshot.pingMs | number : '1.2-2') }}
                </span>
                <small class="speed-test-metric-unit text-muted">ms</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="card speed-test-metric h-100">
            <div class="card-body">
              <p class="speed-test-metric-label text-muted mb-2">
                <i class="feather icon-activity me-1"></i>
                Jitter
              </p>
              <div class="d-flex align-items-baseline gap-1">
                <span class="speed-test-metric-number">
                  {{ snapshot.jitterMs === null ? '—' : (snapshot.jitterMs | number : '1.2-2') }}
                </span>
                <small class="speed-test-metric-unit text-muted">ms</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-2 speed-test-context">
        <div class="col-12 col-md-6">
          <div class="speed-test-context-panel">
            <span
              class="speed-test-context-icon"
              aria-hidden="true"
            >
              <i class="feather icon-wifi"></i>
            </span>
            <div class="speed-test-context-copy">
              <p class="speed-test-context-label text-muted mb-0">Conexión</p>
              <p
                *ngIf="networkContextLoading"
                class="speed-test-context-name mb-0"
              >
                Detectando conexión...
              </p>
              <p
                *ngIf="!networkContextLoading && networkContext"
                class="speed-test-context-name mb-0"
              >
                {{ networkContext.ip || 'No disponible' }}
              </p>
              <p
                *ngIf="!networkContextLoading && !networkContext"
                class="speed-test-context-name mb-0"
              >
                No disponible
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="speed-test-context-panel">
            <span
              class="speed-test-context-icon"
              aria-hidden="true"
            >
              <i class="feather icon-server"></i>
            </span>
            <div class="speed-test-context-copy">
              <p class="speed-test-context-label text-muted mb-0">Servidor</p>
              <p class="speed-test-context-name mb-0">
                {{ speedTestServerName }}
              </p>
              <p class="speed-test-context-detail text-muted mb-0">
                {{ speedTestServerLocation }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <p
        *ngIf="snapshot.status === 'completed' && lastMeasuredAt"
        class="speed-test-last-run text-muted mb-0 mt-3"
      >
        Última medición: {{ lastMeasuredAt | date : 'dd/MM/yyyy HH:mm' }}
      </p>
      </ng-container>
      </ng-container>
    </app-card>
  </div>
</div>
